var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-users"},[_c('school'),_c('school-address'),(_vm.hasModule('finance'))?_c('school-bank'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }